<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == "ausencia-checkin-cliente") {
            next({ name: "ausencia-checkin-cliente-list" });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == "ausencia-checkin-cliente") {
            this.$router.push({ name: "ausencia-checkin-cliente-list" });
        }
    },
};
</script>